import { Injectable, InjectionToken, inject } from '@angular/core';

import { DateCodecService } from './date/date-codec.service';
import { DateService } from './date/date.service';
import type { ArrayMap } from '../domain/common.interface';

export const LINK_REGISTRY_CONFIGURATION = new InjectionToken<LinkRegistryConfiguration>('linkRegistryConfiguration');

export type LinkRegistryConfiguration = Record<string, Link>;

export type LinkParameters = Record<string, unknown | Array<unknown>>;

export class Link {
  url: string = '';
  type?: 'client' | undefined;
  permissions: Array<string> = [];
}

@Injectable({
  providedIn: 'root'
})
export class LinkRegistryService {
  private readonly dateCodecService = inject<DateCodecService>(DateCodecService);
  private linkMap = inject<LinkRegistryConfiguration>(LINK_REGISTRY_CONFIGURATION, { optional: true }) ?? {};

  /**
   *
   * @param linkMap
   * @returns Map with urls as keys and url''s permission as values
   */
  static getUrlPermissions(linkMap: LinkRegistryConfiguration): ArrayMap<string> {
    const permissions: ArrayMap<string> = {};
    Object.keys(linkMap).forEach((key: string): void => {
      const url: Link = linkMap[key];
      if (url.type === 'client') {
        permissions[url.url] = url.permissions;
      }
    });
    return permissions;
  }

  getLink(linkId: string, parameters?: LinkParameters, strict?: boolean): string {
    const linkMapIsDefined = this.linkMap !== undefined;
    const linkIdIsDefined = this.linkMap[linkId] !== undefined;
    let link: string | undefined = linkMapIsDefined && linkIdIsDefined  ? this.linkMap[linkId].url : undefined;

    if (link !== undefined || !strict) {
      if (link === undefined) {
        link = linkId.charAt(0) === '#' ? linkId : '#';
      }
      if (parameters !== undefined) {
        link = this.addParameters(link, parameters);
      }
    }
    return link;
  }

  addParameters(url: string, parameters: LinkParameters): string {
    const parts: Array<string> = [];
    let result: string = url;

    Object.keys(parameters).forEach((key: string): void => {
      let value: unknown | Array<unknown> = parameters[key];

      if (value !== null && value !== undefined) {
        if (!Array.isArray(value)) {
          value = [value];
        }
        (value as Array<string | number | boolean>).forEach((v: string | number | boolean): void => {
          if (DateService.isDate(v)) {
            v = this.dateCodecService.encode(v as unknown as Date) ?? '';
          }
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
        });
      }
    });
    if (parts.length > 0) {
      result += (url.indexOf('?') < 0 ? '?' : '&') + parts.join('&');
    }
    return result;
  }

}
